import React, { Suspense, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './Components/Header/Header';
import Footer from './Components/Footer/Footer';
import RoutesData from './Routes/RoutesData';
import './App.css';
import ScrollToTop from './Components/ScrollTop/ScrollTop';
const seoData = {
  "/": {
    title: "Triplee | Events, Exhibitions & AV Solutions in Saudi Arabia",
    description: "Triplee specializes in exhibitions, conferences, event production, LED screens, professional sound, lighting and AV solutions across Saudi Arabia."
  },
  "/about": {
    title: "About Triplee | Event & Exhibition Production Experts",
    description: "Learn about Triplee, a Saudi-based company specializing in exhibition production, event management, professional audiovisual solutions and conferences."
  },
  "/event": {
    title: "Events & Exhibition Projects | Triplee Saudi Arabia",
    description: "Explore Triplee's event and exhibition services, including conference production, exhibition stands, LED displays, sound systems and professional lighting."
  },
  "/news": {
    title: "News & Insights | Triplee Events",
    description: "Discover news, updates and insights from Triplee about exhibitions, conferences, events and audiovisual technologies in Saudi Arabia."
  },
  "/contact": {
    title: "Contact Triplee | Request an Event or AV Quote",
    description: "Contact Triplee for exhibition stands, event production, LED screens, sound, lighting and professional AV solutions in Saudi Arabia."
  }
};
function SEOManager() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname.replace(/\/+$/, '') || '/';
    const seo = seoData[path] || seoData['/'];

    document.title = seo.title;

    let description = document.querySelector('meta[name="description"]');

    if (!description) {
      description = document.createElement('meta');
      description.setAttribute('name', 'description');
      document.head.appendChild(description);
    }

    description.setAttribute('content', seo.description);

    let canonical = document.querySelector('link[rel="canonical"]');

    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }

    canonical.setAttribute(
      'href',
      `https://www.triplee.sa${path === '/' ? '/' : path}`
    );
  }, [location.pathname]);

  return null;
}
function App() {
  return (
    <div className="App trible-site-main">
      <Router basename='/'>
<SEOManager />
        <div className='navbar-main'>
          <Header />
        </div>
        <Suspense>
          <ScrollToTop />
          <Routes>
            {RoutesData.map((data, i) => (
              <Route
                key={i}
                path={data.path}
                element={<data.element />}
              />

            ))}

          </Routes>
        </Suspense>
        <div className='footer-main'>
          <Footer />
        </div>
      </Router>
    </div>
  );
}

export default App;
